import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CouponsContainer = styled(Box)`
  text-align: initial;
`;
